
/**
  * @ngdoc service
  * @name common.service:ItxProductSvc
  * 
  * @description
  * Description...
  *
  * @example
  * example...
**/
(function () {
    'use strict';

    angular.module('itxApp.common')
        .service('ItxProductSvc', ItxProductSvc);

    ItxProductSvc.$inject = [
        '$q',
        'Product',
        'ItxUtilsFct',
        'itxAkamaiSvc'
    ];

    function ItxProductSvc( 
        $q,
        Product,
        ItxUtilsFct,
        itxAkamaiSvc
    ){
        
        var service = {
            getType: getType,
            getCompleteLookProducts: getCompleteLookProducts,
            itemOutOfStock: _itemOutOfStock
        };
        return service;

        // @params product Object 
        // return String 'upper_part', 'lower_part', 'accessory', 'footwear', 'extras'
        function getType(product) {
            var res = 'upper_part';
            var productType = {
                'lower_part': {
                    'family': [5, 6, 10, 16, 29, 32, 40, 50, 52, 69],
                    'subFamily': [505, 506, 510, 516, 381, 380, 532, 974, 441, 446, 444, 456, 440, 442, 971, 972, 976, 895, 970, 901, 762, 452, 457, 455, 451, 450, 459, 569] // jshint ignore:line
                },
                'upper_part': {
                    'family': [1, 2, 3, 4, 7, 9, 14, 17, 18, 20, 24, 25, 27, 28, 29, 33, 34, 40, 49, 50, 52, 66],
                    'subFamily': [110, 106, 700, 701, 501, 601, 502, 517, 881, 703, 602, 503, 603, 739, 607, 617, 761, 763, 187, 469, 776, 778, 777, 609, 509, 253, 250, 252, 644, 514, 564, 664, 574, 824, 826, 287, 317, 307, 316, 618, 518, 521, 325, 321, 851, 520, 620, 896, 850, 351, 870, 872, 525, 625, 524, 367, 892, 627, 527, 891, 890, 374, 528, 529, 629, 372, 282, 947, 533, 633, 340, 951, 884, 854, 894, 897, 704, 649, 549, 550, 654, 651, 653, 554, 552, 461, 468, 476, 467, 462, 568, 566, 567]  // jshint ignore:line
                },
                'accessories': {
                    'family': [5, 6, 10, 11, 12, 13, 15, 16, 21, 26, 30, 31, 32, 40, 43, 44, 45, 69],
                    'subFamily': [128, 749, 605, 752, 606, 751, 208, 488, 610, 781, 780, 799, 806, 800, 805, 819, 268, 839, 849, 856, 616, 669, 869, 880, 398, 408, 929, 632, 939, 845, 428, 438, 969, 498]  // jshint ignore:line
                },
                'footwear': {
                    'family': [2, 5, 6, 7, 8, 9, 10, 12, 13, 21, 23, 24, 25, 41, 57, 58, 64, 67, 68, 69, 70],
                    'subFamily': [613, 633, 626, 663, 614, 612, 625, 662, 632, 670, 665, 635, 622, 631, 661, 611, 624, 616, 615, 623]
                },
                'extras': {
                    'family': [2, 3],
                    'subFamily': [716, 717, 721]
                }
            };

            if( _indexOf(product, productType.upper_part) ){
                res = 'upper_part';
            } else if( _indexOf(product, productType.lower_part) ){
                res = 'lower_part';
            } else if( _indexOf(product, productType.accessories) ){
                res = 'accessory';
            } else if( _indexOf(product, productType.footwear) ){
                res = 'footwear';
            } else if( _indexOf(product, productType.extras) ){
                res = 'extras';
            }
            return res;
        }


        function getCompleteLookProducts(arrayProducts, quantity){
            var deferred = $q.defer();
            if(!arrayProducts){
                arrayProducts = [[]];
            }
            var arrayPromises = [];

            var arrayIdsProducts = _.map( _.uniq(_.flatten(arrayProducts)) , 'product_id');
            if(arrayIdsProducts.length === 0){
                deferred.resolve([]);
            }

            joyr.rest.xRestGetProductStock(arrayIdsProducts)
            .done(function (productStocks) {

                //Filter products with stock only
                var arrayIdStock = _.filter(productStocks, { stocks: [{availability: 'in_stock'}]  });
                arrayIdStock = _.map(arrayIdStock, 'productId');
                _.each( arrayProducts, function (ap) {
                    arrayPromises = _.concat(arrayPromises, _getMoreProducts(-1, ap,arrayIdStock, productStocks, quantity) ) ;
                });
                $q.all( arrayPromises )
                .then(function(data) {
                    var product = _.flatten(data);
                    var newArrayProducts = _generateProductArray(product , _.flatten(arrayProducts), productStocks);
                    deferred.resolve( newArrayProducts );
                });
            })
            .Catch(function (e) {
                console.error('Related stocks error ' + e );
                deferred.reject();
            });
            return deferred.promise;
        }
      
        // PRIVATE


         /**
         * @ngdoc method
         * @name _getMoreProducts
         * @methodOf  common.service:ItxProductSvc
         * @description
         * Returns one product recursively or returns an empty array if there are not valid products
         */
       
        function _getMoreProducts(lastIndex, arrayProducts, arrayIdStock, productStocks, quantity) {
            var deferred = $q.defer();
            if (lastIndex >= arrayProducts.length - 1 || arrayProducts.length === quantity) {
                deferred.resolve([]);
            } else {
                var products = [];
                var found = false;
                var product;
                for (var i = lastIndex + 1; i < arrayProducts.length - 1; ++i) {
                    product = arrayProducts[i];
                    if (!found && product && _.includes(arrayIdStock, product.product_id)) {
                        found = true;
                        joyr.rest.xRestGetProductDetail(product.product_id).then(function(data) {
                            products.push(data);
                            var result = _generateProductArray(products, arrayProducts, productStocks);
                            if (result.length < 1) {
                                deferred.resolve( _getMoreProducts(i, arrayProducts, arrayIdStock, productStocks, quantity));
                            } else {
                                deferred.resolve(result);
                            }

                        });
                    }
                }
                if (!found) {
                    deferred.resolve([]);
                }
            }
            return deferred.promise;

        }

        function _generateProductArray(products, arrayProducts, productStocks){
            var result = [];
            var product;
            var stockProduct;
            var visibilityMap;
            var _selectedColorIndex = 0;

            _.each(products, function(p){
                product = new Product(p);
                if(product && product.activeDetail.colors.length > 0){

                    //Search product and sets its visibility
                    stockProduct =  new Array(_.find(productStocks, {'productId': product.id}));
                    visibilityMap = inditex.getProductVisibilityMap( new Array(product) , stockProduct);
                    joyr.catalog.visibility.setVisibility(product, visibilityMap);

                    // Set default product color
                    var filtered =  _.find(arrayProducts, {'product_id': product.id});
                    if (filtered && filtered.colorId) {
                        _selectedColorIndex = _.findIndex(product.activeDetail.colors, function(color) {
                            return color.id === filtered.colorId.toString();
                        });
                        _selectedColorIndex = _selectedColorIndex !== -1 ? _selectedColorIndex : 0;
                    }
                    product.state.selectedColorIndex = _selectedColorIndex;
                    product.state.selectedColor = product.activeDetail.colors[_selectedColorIndex];

                    var images = ItxUtilsFct.getImageProductUrls( product.activeDetail, filtered.colorId || null , 'relatedProduct', 'siluet2', 'grid' );                                                      
                    var url = product.getUrl();
                    
                    if( url && images && images.length > 0 ) {    
                        // Cargamos la silueta con fondo blanco 
                        var img = images[0]; 
                        if(img && img.indexOf('_5_')){
                            img = img.replace('_5_', '_4_');
                        }

                        product.state.url = url;
                        product.state.images = {
                            siluet: itxAkamaiSvc.useAkamaiImage(img, 299)
                        };
                        product.setRelated(true);
                        result.push(product);
                    }
                }
            });
            return result;
        }

        function _indexOf(product, array) {
            var family = false;
            var subFamily = false;
            if( _isInArray( parseInt(product.family), array.family) ){
                family = true;
            }
            if( _isInArray( parseInt(product.subFamily), array.subFamily) ){
                subFamily = true;
            } 
            return subFamily;
        }

        function _isInArray(value, array) {
            return array.indexOf(value) > -1;
        }

        function _itemOutOfStock(product) {
            if (!product || product.visibility === 'hidden' || !product.isBuyable) {
                return true;
            }
            if(product.state.selectedColor){
                var size = _isUniqueSize(product);
                return (size.visibility === 'disabled' || size.visibility === 'coming_soon' || size.visibility === 'back_soon');
            } else {
                return product.visibility === 'show';
            }
        }

        function _isUniqueSize(product) {
            if (!product) {
                return false;
            }
            var sizes = product.activeDetail.colors[ product.state.selectedColorIndex ].sizes;
            if (sizes && sizes.length && sizes.length === 1 && sizes[0].name === '01') {
                return sizes[0];
            } else {
                return false;
            }
        }

    }

})();

